import { DevicesActionTypes } from '../types';
import { TOGGLE_SELECT_ALL_DEVICES } from '../constants/actionTypes';

export const toggleSelectAllDevices = (isChecked: boolean): DevicesActionTypes => ({
  type: TOGGLE_SELECT_ALL_DEVICES,
  payload: isChecked,
});
